(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["summer-discount-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-nv-summer-discount]');
    if (!banner) return;

    const closeButton = banner.querySelector('[data-nv-summer-discount-close]');
    const countdown = banner.querySelector('[data-nv-summer-discount-countdown]');
    const promotionEndsAt = Date.parse(banner.dataset.nvPromotionEndsAt || '');
    const impressionKey = 'nv-promo-ottobre-2026-10-31-v1';
    const maximumImpressions = 1;
    let closeTimer;
    let countdownTimer;

    const readImpressions = () => {
      try {
        return Number.parseInt(window.sessionStorage.getItem(impressionKey) || '0', 10) || 0;
      } catch (error) {
        return 0;
      }
    };

    const writeImpressions = (value) => {
      try {
        window.sessionStorage.setItem(impressionKey, String(value));
      } catch (error) {
        return;
      }
    };

    const markPromotionExpired = () => {
      document.documentElement.classList.add('nv-summer-promotion-expired');
    };

    const updateCountdown = () => {
      const remainingMilliseconds = promotionEndsAt - Date.now();
      if (!Number.isFinite(promotionEndsAt) || remainingMilliseconds <= 0) {
        markPromotionExpired();
        closeBanner();
        return false;
      }

      const totalSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (countdown) {
        countdown.dateTime = new Date(promotionEndsAt).toISOString();
        countdown.textContent = days > 0
          ? `${days}g ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`
          : `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      }
      return true;
    };

    function closeBanner() {
      window.clearTimeout(closeTimer);
      window.clearInterval(countdownTimer);
      banner.classList.remove('is-visible');
      window.setTimeout(() => {
        banner.hidden = true;
      }, 220);
    }

    const showBanner = () => {
      if (!updateCountdown()) return;
      const impressions = readImpressions();
      if (impressions >= maximumImpressions) return;
      writeImpressions(impressions + 1);
      banner.hidden = false;
      window.requestAnimationFrame(() => {
        banner.classList.add('is-visible');
        countdownTimer = window.setInterval(updateCountdown, 1000);
        closeTimer = window.setTimeout(closeBanner, 12000);
      });
    };

    closeButton?.addEventListener('click', closeBanner);
    if (!updateCountdown()) return;
    if (document.readyState === 'complete') {
      window.setTimeout(showBanner, 600);
    } else {
      window.addEventListener('load', () => window.setTimeout(showBanner, 600), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
